import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "../lib/api";
import { Logo } from "../components/Logo";

export default function InviteAccept() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("joining");
  const [name, setName] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      try {
        const res = await api.post(`/projects/invite/${token}/accept`);
        setName(res.data.name || "the project");
        setStatus("joined");
        setTimeout(() => navigate(`/project/${res.data.project_id}`), 1200);
      } catch {
        setStatus("invalid");
      }
    })();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center grid-bg px-6">
      <div className="glass rounded-2xl p-10 max-w-md w-full text-center">
        <div className="mb-6 flex justify-center"><Logo size="lg" /></div>
        {status === "joining" && <><Loader2 className="h-10 w-10 text-indigo-400 animate-spin mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold">Joining project…</h1></>}
        {status === "joined" && <><CheckCircle2 className="h-10 w-10 text-emerald-400 mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold mb-1">You're in! 🎉</h1><p className="text-slate-400">Opening {name}…</p></>}
        {status === "invalid" && <><XCircle className="h-10 w-10 text-rose-400 mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold mb-2">Invite invalid</h1><p className="text-slate-400 mb-6">This invite link is expired or not valid.</p><button onClick={() => navigate("/dashboard")} className="px-6 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-500 font-semibold transition-colors">Go to dashboard</button></>}
      </div>
    </div>
  );
}
